import React, { useEffect } from 'react';
import styled from 'styled-components';
import { media } from '@peloton/styles';
import { track } from '@engage/analytics';
import { clearAll as clearFiltersAction, getFilterAnalyticsProps } from '@engage/filters';
import {
  trackViewedEmptyLibraryPage,
  EmptyLibrarySource,
  EmptyStateType,
} from '@engage/library';
import { useReduxAction, useReduxState } from '@engage/redux';
import { getBlockExplicit, getClassLanguagePreferences } from '@engage/settings';
import { spaces } from '@engage/styles';
import { header3Large, header5Large } from '@engage/typography';
import { Button1Medium } from '@members/buttons';
import { ClassesCopy } from '@members/copy';
import { Classes } from '@members/copy/models.generated/Classes';

const NoClassesBecauseFilters: React.FC<React.PropsWithChildren<unknown>> = () => {
  const trackAction = useReduxAction(track);
  const classLanguageSettings = useReduxState(getClassLanguagePreferences);
  const browseProps = useReduxState(getFilterAnalyticsProps);
  const explicitBlocked = useReduxState(getBlockExplicit);
  useEffect(() => {
    trackAction(
      trackViewedEmptyLibraryPage(
        EmptyLibrarySource.Library,
        EmptyStateType.NoClasses,
        classLanguageSettings,
        explicitBlocked,
        browseProps,
      ),
    );
  }, []);
  const clearFilters = useReduxAction(clearFiltersAction);
  const onClick = () => clearFilters(NO_CLASSES_ANALYTICS_SOURCE);
  return (
    <Content>
      <Message data-test-id="noClassesMessage">
        <ClassesCopy id={Classes.NoClassesFound} />
      </Message>
      <Button1Medium data-test-id="showAllClassesButton" onClick={onClick}>
        <ClassesCopy id={Classes.ShowAllClasses} />
      </Button1Medium>
    </Content>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spaces.giant}px 0 145px;
  ${media.tablet`
    margin-top: 120px;
  `}
`;

const Message = styled.h1`
  ${header5Large}
  margin-bottom: ${spaces.large}px;
  ${media.tablet`
    ${header3Large}
    margin-bottom: ${spaces.huge}px;
  `}
`;

const NO_CLASSES_ANALYTICS_SOURCE = 'No Classes';

export default NoClassesBecauseFilters;
